import React, { useEffect, useState } from 'react'
import { MdClose, MdMoreVert } from 'react-icons/md'
import ReactApexChart from 'react-apexcharts'
import { collection, getDocs, query, where } from 'firebase/firestore'
import { db } from '../../firebase'
import { toast } from "react-toastify"
import { getPiecesPercent } from '../../utils/getPiecesPercent'

const EmployeeView = ({employeeToView, setEmployeeToView}) => {
    const [showTotalTime, setShowTotalTime] = useState(false)
    const [options, setOptions] = useState({
        series: [0, 0],
        options: {
          labels: ['A', 'B'],
        },
      }
    )

    useEffect(() => {
        const getProductedPercent = async () => {    
          const q = query(collection(db, "machine_job_stats"), where('employeeId', '==', employeeToView?.id ))
    
          const stats_Snap = await getDocs(q);
          if (!stats_Snap.empty) {
            let data = [];
            stats_Snap.forEach((doc) => {
              data.push({ ...doc.data(), id: doc.id, day: doc.data().timestamp.toDate().getDate() })
            })
            const percents = getPiecesPercent(data)
            setOptions({
                series: [percents.badPiecesPercent, percents.productedPiecesPercent],
                options: {
                  labels: ['Bad %', 'Producted %'],
                },
            })
            
        }else{
            toast.error('No results found related to given date.')
          }
        }
        getProductedPercent()
      }, [employeeToView.id])
    
    return (
        <>
            {Object.keys(employeeToView).length !==0 && <><div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed top-0 right-0 left-0 bottom-0 m-auto z-50 outline-none focus:outline-none"
            >
                <div className="relative">
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col max-h-[90vh] w-[100vw] sm:w-[80vw] bg-white outline-none focus:outline-none">
                        {/*header*/}
                        <div className="flex items-center justify-between px-3 py-0 border-b border-solid border-slate-200 rounded-t">
                        <ul className="nav nav-tabs flex flex-row flex-wrap list-none border-b-0 pl-0" id="tabs-tabFill"
                            role="tablist">
                            <li className="nav-item text-center" role="presentation">
                                <a href="#tabs-homeFill" className="
                                nav-link
                                rounded-t-md
                                w-full
                                block
                                font-semibold
                                text-md
                                border-x-0 border-t-0 border-b-2 border-transparent
                                px-5
                                py-2
                                my-2
                                hover:border-transparent hover:bg-gray-100
                                focus:border-transparent
                                active
                                " id="tabs-home-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-homeFill" role="tab"
                                aria-controls="tabs-homeFill" aria-selected="true">Profile</a>
                            </li>
                            <li className="nav-item text-center" role="presentation">
                                <a href="#tabs-profileFill" className="
                                nav-link
                                rounded-t-md
                                w-full
                                block
                                font-semibold
                                text-md
                                border-x-0 border-t-0 border-b-2 border-transparent
                                px-5
                                py-2
                                my-2
                                hover:border-transparent hover:bg-gray-100
                                focus:border-transparent
                                " id="tabs-profile-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-profileFill" role="tab"
                                aria-controls="tabs-profileFill" aria-selected="false">Stats</a>
                            </li>
                            </ul>
                            <MdClose onClick={()=> setEmployeeToView({})} className='text-2xl cursor-pointer font-bold text-black' />
                        </div>
                        {/*body*/}
                        <div className='p-2 sm:p-5 min-h-[200px]'>
                            <div className="tab-content" id="tabs-tabContentFill">
                                <div className="tab-pane fade show active" id="tabs-homeFill" role="tabpanel" aria-labelledby="tabs-home-tabFill">
                                    <div className="flex items-center">
                                        <img src={employeeToView.imageUrl? employeeToView.imageUrl :'https://www.seekpng.com/png/detail/428-4287240_no-avatar-user-circle-icon-png.png'} className='w-20 sm:w-40 h-20 sm:h-40 rounded-full object-cover' alt="" />
                                        <div className="flex flex-col ml-2 sm:ml-5 space-y-3 sm:space-y-8">
                                            <span className='font-semibold text-xl sm:text-5xl'>{employeeToView.name}</span>
                                            <span className='text-gray-500 text-lg'>{employeeToView.email}</span>
                                        </div>
                                    </div>
                                    <hr className='my-3'/>
                                    <div className="flex flex-col max-w-md">
                                        <div className="flex items-center w-full justify-between my-2">
                                            <span className='font-semibold'>Phone Number</span>
                                            <span className='text-gray-600'>{employeeToView.phone}</span>
                                        </div>
                                        <div className="flex items-center w-full justify-between my-2">
                                            <span className='font-semibold'>Password</span>
                                            <span className='text-gray-600'>*********</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="tabs-profileFill" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
                                    <div className="flex flex-col lg:flex-row items-center lg:justify-between ">
                                        <div className="flex w-full lg:max-w-sm items-start flex-col">
                                            <div className="flex items-center w-full justify-between my-2">
                                                <span className='font-semibold text-gray-800'>Asigned Jobs</span>
                                                <span className='text-gray-600'>some job</span>
                                            </div>
                                            <div className="flex items-center w-full justify-between my-2 relative group">
                                                <MdMoreVert onClick={()=> setShowTotalTime(prev=> !prev)} className='absolute -top-3 -right-5 text-gray-800 text-xl scale-0 group-hover:scale-100 transition-all duration-200 cursor-pointer' />
                                                <span className='font-semibold text-gray-800'>Total Working Time</span>
                                                <span className='text-gray-600'>10:10:28</span>
                                                <div className={`flex flex-col bg-white border z-30 border-gray-300 px-3 py-2 rounded-lg shadow-xl transition-all duration-200 scale-0 absolute right-[-90px] top-[-66px] ${showTotalTime && 'scale-100 top-[-1px] right-[-2px]'}`}>
                                                    <span className='font-semibold text-base text-slate-600 pb-1 border-b border-gray-300'>Select Range</span>
                                                    <div className="flex space-x-2 items-center my-2">
                                                    <span className='text-xs text-thin'>Start At</span>
                                                    <input type="date" className='w-36 bg-gray-100 py-1 px-2 rounded-md shadow outline-1 outline-gray-400 focus:outline-blue-500' />
                                                    </div>
                                                    <div className="flex space-x-2 items-center mb-2">
                                                        <span className='text-xs text-thin'>End At</span>
                                                        <input type="date" className='w-36 bg-gray-100 py-1 px-2 rounded-md shadow outline-1 outline-gray-400 focus:outline-blue-500' />
                                                    </div>
                                                    <button className='py-1 rounded-md text-white my-1 btn-color transition-all duration-200'>Clear</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex lg:max-w-sm">
                                            <ReactApexChart options={options.options} series={options.series} className='w-full h-44' type="pie"  />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*footer*/}
                        {/* <div className="flex items-center justify-end p-2 border-t border-solid border-slate-200 rounded-b">

                        </div> */}
                    </div>
                </div>
            </div>
            <div className="opacity-40 fixed inset-0 z-40 bg-black"></div></>}
        </>
    )
}

export default EmployeeView